import React from 'react'
import './ValidationItem.css'
import greentick from '../../../assets/images/done.svg';
import redtick from '../../../assets/images/clear.svg';
import useLanguageTranslate from '../../../hooks/useLanguageTranslate';

/**
 * One line of a requirements checklist (e.g. password rules).
 *
 * Three states: `is_pending` (nothing typed yet) shows a neutral dot, so the
 * list does not open as a column of red failures; after that, a tick or a
 * cross. All three sit in the same fixed 20px slot. The tick and cross assets
 * are different sizes (16px and 24px), so without the slot every line's text
 * jumped sideways as a rule flipped.
 *
 * The icon is keyed by state, so each change remounts it and it pops in
 * (.validation-icon-in, index.css): the rule visibly responds to typing.
 */
const ValidationItem = ({ className, is_validated, is_pending = false, msg }) => {
    const translate = useLanguageTranslate();
    const state = is_pending ? 'pending' : is_validated ? 'valid' : 'invalid';
    return (
        <div className={`flex items-center ${className || ''}`}>
            <span
                aria-hidden="true"
                className='flex w-5 h-5 shrink-0 items-center justify-center mr-2 rtl:mr-0 rtl:ml-2'
            >
                <span key={state} className='validation-icon-in flex items-center justify-center'>
                    {is_pending ? (
                        <span className='block w-1.5 h-1.5 rounded-full bg-[#B0BABF]' />
                    ) : is_validated ? (
                        <img src={greentick} alt='' className='w-4 h-4' />
                    ) : (
                        <img src={redtick} alt='' className='w-4 h-4' />
                    )}
                </span>
            </span>
            <p className="validation_msg">{translate(msg.en, msg.ar)}</p>
        </div>
    )
}

export default ValidationItem
